const requireModule = require.context('.', true, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
	if (fileName.endsWith('index.js')) return
	const moduleName = fileName.replace(/(\.\/|\.js)/g, '')
	modules[moduleName] = requireModule(fileName).default
})

export default modules
